import dayjs from 'dayjs';
import { BOOST_REWARDS_MAX_LENGTH, BOOST_REWARDS_MIN_LENGTH } from '../config';

export const getEndDateMin = () => {
  return dayjs().add(BOOST_REWARDS_MIN_LENGTH, 'month').endOf('month').format('YYYY-MM-DD');
};

export const getEndDateMax = (billingDay: number) => {
  if (billingDay < dayjs().date()) {
    // If the billing day has already passed this month, we need to subtract one month from the max end date.
    return dayjs()
      .add(Number(BOOST_REWARDS_MAX_LENGTH) + 1, 'month')
      .endOf('month')
      .format('YYYY-MM-DD');
  }
  return dayjs().add(BOOST_REWARDS_MAX_LENGTH, 'month').endOf('month').format('YYYY-MM-DD');
};
